// extracted by mini-css-extract-plugin
module.exports = {"icon":"FGmSf_","infoIcon":"JRO9X_"};